export const AUDIT_OPERATIONS = Object.freeze({
  CREATE: "create",
  UPDATE: "update",
  AMEND: "amend",
  DELETE: "delete",
  SYNC: "sync",
});

export const isAuditOperation = (value) =>
  Object.values(AUDIT_OPERATIONS).includes(value);
